import { ActionType, createReducer } from 'typesafe-actions';
import { setHotColdAnalytics } from './actions';
import { IHotColdAnalytics } from './types';

export const defaultStatistics: IHotColdAnalytics = {
  hotColdAnalytics: [],
};

const actions = {
  setHotColdAnalytics,
};

export const hotColdAnalyticsReducer = createReducer<IHotColdAnalytics, ActionType<typeof actions>>(
  defaultStatistics,
).handleAction(setHotColdAnalytics, (state, { payload }) => ({
  ...state,
  hotColdAnalytics: payload,
}));
